module.exports = __webpack_public_path__ + "static/media/dropbox-icon.38b8949c.svg";